import { Component, OnInit } from '@angular/core';
import { UtilsService } from '@shared/services/utils.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BehaviorSubject } from 'rxjs';
import { MenuService } from '../services/menu.service';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ["./mobile-menu.component.scss"],
  animations: [
    trigger('slide', [
      state('slideIn', style({ 'pointer-events': 'auto', transform: 'translateY(0)' })),
      transition('* => *', animate(300))
    ])
  ]
})
export class MobileMenuComponent implements OnInit {

  menu$: BehaviorSubject<boolean>;
  routes: any;

  constructor(private utils: UtilsService, private menu: MenuService) {
  }

  ngOnInit() {
    this.utils.menu$.subscribe(() => {
      this.routes = this.menu.getMenu();
    })
    this.menu$ = this.utils.menu$;
  }

  closeMenu() {
    this.menu$.next(false);
  }

}
